import { connect } from "react-redux";
import { getOperatorEmail, isOperatorMode } from "app/pages/Auth/authSelectors";
import OperatorWidget from "app/pages/.shared/OperatorWidget/OperatorWidget";
import { logout } from "app/pages/Auth/AuthActions";
import { bindActionCreators } from "redux";

const mapStateToProps = state => {
	return {
		operatorEmail: getOperatorEmail(state),
		isOperatorMode: isOperatorMode(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ logout }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorWidget);
